import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase } from '@digibricks/core';
import { QuestionType, SingleChoiceCorrectAnswer, MultipleChoiceCorrectAnswer } from '../../domain';
export var UPDATE_CORRECT_ANSWER_USE_CASE = 'UPDATE_CORRECT_ANSWER_USE_CASE';
export var UpdateCorrectAnswerUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateCorrectAnswerUseCase, _UseCase);

  var _super = _createSuper(UpdateCorrectAnswerUseCase);

  function UpdateCorrectAnswerUseCase() {
    _classCallCheck(this, UpdateCorrectAnswerUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(UpdateCorrectAnswerUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var currentQuestion, data, updatedResults, answerIds, question, correctAnswers, _correctAnswers, resultCombine;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentQuestion = input.currentQuestion, data = input.data;
                updatedResults = [];
                answerIds = data.answerIds;
                question = currentQuestion;
                _context.t0 = currentQuestion.type;
                _context.next = _context.t0 === QuestionType.SingleChoice ? 7 : _context.t0 === QuestionType.MultipleChoice ? 10 : 13;
                break;

              case 7:
                correctAnswers = answerIds.map(function (id) {
                  return SingleChoiceCorrectAnswer.create({
                    answerId: id
                  }).getValue();
                });
                updatedResults.push(question.updateCorrectAnswers(correctAnswers));
                return _context.abrupt("break", 13);

              case 10:
                _correctAnswers = answerIds.map(function (id) {
                  return MultipleChoiceCorrectAnswer.create({
                    answerId: id
                  }).getValue();
                });
                updatedResults.push(question.updateCorrectAnswers(_correctAnswers));
                return _context.abrupt("break", 13);

              case 13:
                resultCombine = Result.combine(updatedResults);

                if (!resultCombine.isFailure) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return", mappingResultError(resultCombine));

              case 16:
                return _context.abrupt("return", Result.ok(question));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return UpdateCorrectAnswerUseCase;
}(UseCase);